"use client";

import { c as _c } from "react/compiler-runtime";
import { MarketplaceIcon } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { useCurrency } from "@opensea/navigation";
import { AnimatedNumber, classNames, FlexCenter, NumberDisplay, TextOverflowTooltip, Tooltip, textColorVariants } from "@opensea/ui-kit";
import { UnreachableCaseError } from "@opensea/utils";
import { TokenPriceFragment } from "./TokenPrice.fragment";
import { useUsdPriceValue } from "./use-usd-price";
export function TokenPriceDisplay(t0) {
  const $ = _c(78);
  let animated;
  let children;
  let className;
  let contractAddress;
  let currencyProp;
  let disableTooltip;
  let marketplace;
  let marketplaceIconClassName;
  let rest;
  let symbol;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let unit;
  let usdPrice;
  if ($[0] !== t0) {
    ({
      children,
      className,
      contractAddress,
      currency: currencyProp,
      symbol,
      unit,
      usdPrice,
      marketplace,
      chain: t1,
      marketplaceIconSide: t2,
      marketplaceIconSize: t3,
      marketplaceIconClassName,
      display: t4,
      conversion: t5,
      multiplier: t6,
      symbolColor: t7,
      valueColor: t8,
      animated,
      disableTooltip,
      bounded: t9,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = animated;
    $[2] = children;
    $[3] = className;
    $[4] = contractAddress;
    $[5] = currencyProp;
    $[6] = disableTooltip;
    $[7] = marketplace;
    $[8] = marketplaceIconClassName;
    $[9] = rest;
    $[10] = symbol;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = unit;
    $[21] = usdPrice;
  } else {
    animated = $[1];
    children = $[2];
    className = $[3];
    contractAddress = $[4];
    currencyProp = $[5];
    disableTooltip = $[6];
    marketplace = $[7];
    marketplaceIconClassName = $[8];
    rest = $[9];
    symbol = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
    unit = $[20];
    usdPrice = $[21];
  }
  const chain = t1 === undefined ? "ethereum" : t1;
  const marketplaceIconSide = t2 === undefined ? "right" : t2;
  const marketplaceIconSize = t3 === undefined ? 20 : t3;
  const display = t4 === undefined ? "standard" : t4;
  const conversion = t5 === undefined ? "current" : t5;
  const multiplier = t6 === undefined ? 1 : t6;
  const symbolColor = t7 === undefined ? "text-secondary" : t7;
  const valueColor = t8 === undefined ? "text-primary" : t8;
  const bounded = t9 === undefined ? true : t9;
  const {
    currency: currencyContext
  } = useCurrency();
  const currency = currencyProp ?? currencyContext;
  const NumberComponent = animated ? AnimatedNumber : NumberDisplay;
  let t10;
  if ($[22] !== chain || $[23] !== contractAddress) {
    t10 = contractAddress ? {
      contractAddress,
      chainIdentifier: chain
    } : undefined;
    $[22] = chain;
    $[23] = contractAddress;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== conversion || $[26] !== multiplier || $[27] !== t10 || $[28] !== unit || $[29] !== usdPrice) {
    t11 = {
      currency: t10,
      unitPrice: unit,
      usdPrice,
      conversion,
      multiplier
    };
    $[25] = conversion;
    $[26] = multiplier;
    $[27] = t10;
    $[28] = unit;
    $[29] = usdPrice;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const usdPriceValue = useUsdPriceValue(t11);
  const cryptoPriceValue = typeof unit === "number" ? unit * multiplier : undefined;
  let t12;
  if ($[31] !== valueColor) {
    t12 = textColorVariants({
      color: valueColor
    });
    $[31] = valueColor;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== NumberComponent || $[34] !== bounded || $[35] !== cryptoPriceValue || $[36] !== display || $[37] !== t12) {
    t13 = <NumberComponent bounded={bounded} className={t12} display={display} value={cryptoPriceValue} />;
    $[33] = NumberComponent;
    $[34] = bounded;
    $[35] = cryptoPriceValue;
    $[36] = display;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== symbol || $[40] !== symbolColor) {
    t14 = symbol ? <span className={classNames(textColorVariants({
      color: symbolColor
    }), "font-mono")}> {symbol}</span> : null;
    $[39] = symbol;
    $[40] = symbolColor;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t13 || $[43] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  const cryptoPriceComponent = t15;
  let t16;
  if ($[45] !== valueColor) {
    t16 = textColorVariants({
      color: valueColor
    });
    $[45] = valueColor;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== NumberComponent || $[48] !== t16 || $[49] !== usdPriceValue) {
    t17 = <NumberComponent className={t16} display="usd" value={usdPriceValue} />;
    $[47] = NumberComponent;
    $[48] = t16;
    $[49] = usdPriceValue;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  const usdPriceComponent = t17;
  let t18;
  if ($[51] !== cryptoPriceComponent || $[52] !== currency || $[53] !== usdPriceComponent) {
    t18 = () => {
      switch (currency) {
        case "crypto":
          {
            return cryptoPriceComponent;
          }
        case "usd":
          {
            return usdPriceComponent;
          }
        default:
          {
            throw new UnreachableCaseError(currency);
          }
      }
    };
    $[51] = cryptoPriceComponent;
    $[52] = currency;
    $[53] = usdPriceComponent;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  const formatPrice = t18;
  let t19;
  if ($[55] !== marketplace || $[56] !== marketplaceIconClassName || $[57] !== marketplaceIconSize) {
    t19 = marketplace ? {
      market: marketplace,
      size: marketplaceIconSize,
      className: marketplaceIconClassName
    } : null;
    $[55] = marketplace;
    $[56] = marketplaceIconClassName;
    $[57] = marketplaceIconSize;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  const marketplaceProps = t19;
  let t20;
  if ($[59] !== marketplaceProps) {
    t20 = marketplaceProps ? <div className="shrink-0"><MarketplaceIcon {...marketplaceProps} /></div> : null;
    $[59] = marketplaceProps;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  const marketplaceIcon = t20;
  const t21 = currency === "crypto" ? usdPriceComponent : cryptoPriceComponent;
  const t22 = disableTooltip || currency === "crypto" && usdPriceValue === undefined || currency === "usd" && cryptoPriceValue === undefined;
  let t23;
  if ($[61] !== className) {
    t23 = classNames("inline-flex gap-1 truncate", className);
    $[61] = className;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  const t24 = marketplaceIconSide === "left" ? marketplaceIcon : null;
  let t25;
  if ($[63] !== children || $[64] !== formatPrice) {
    t25 = children ?? formatPrice();
    $[63] = children;
    $[64] = formatPrice;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== t25) {
    t26 = <TextOverflowTooltip className="flex items-center">{t25}</TextOverflowTooltip>;
    $[66] = t25;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  const t27 = marketplaceIconSide === "right" ? marketplaceIcon : null;
  let t28;
  if ($[68] !== rest || $[69] !== t23 || $[70] !== t24 || $[71] !== t26 || $[72] !== t27) {
    t28 = <FlexCenter className={t23} {...rest}>{t24}{t26}{t27}</FlexCenter>;
    $[68] = rest;
    $[69] = t23;
    $[70] = t24;
    $[71] = t26;
    $[72] = t27;
    $[73] = t28;
  } else {
    t28 = $[73];
  }
  let t29;
  if ($[74] !== t21 || $[75] !== t22 || $[76] !== t28) {
    t29 = <Tooltip content={t21} disabled={t22}>{t28}</Tooltip>;
    $[74] = t21;
    $[75] = t22;
    $[76] = t28;
    $[77] = t29;
  } else {
    t29 = $[77];
  }
  return t29;
}
export function TokenPrice(t0) {
  const $ = _c(12);
  let priceKey;
  let rest;
  if ($[0] !== t0) {
    ({
      price: priceKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = priceKey;
    $[2] = rest;
  } else {
    priceKey = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== priceKey) {
    t1 = readFragment(TokenPriceFragment, priceKey);
    $[3] = priceKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const price = t1;
  const t2 = price?.token.chain.identifier;
  const t3 = price?.token.contractAddress;
  const t4 = price?.token.symbol;
  const t5 = price?.token.unit;
  const t6 = price?.usd;
  let t7;
  if ($[5] !== rest || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <TokenPriceDisplay chain={t2} contractAddress={t3} symbol={t4} unit={t5} usdPrice={t6} {...rest} />;
    $[5] = rest;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}